import { render, staticRenderFns } from "./pendingOrderCard.vue?vue&type=template&id=3d64f1d1&scoped=true"
import script from "./pendingOrderCard.vue?vue&type=script&lang=js"
export * from "./pendingOrderCard.vue?vue&type=script&lang=js"
import style0 from "./pendingOrderCard.vue?vue&type=style&index=0&id=3d64f1d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64f1d1",
  null
  
)

export default component.exports